import * as React from "react";
import Seo from "../components/seo";
import { Link } from "gatsby";
import { Container, Row, Col, Image, } from "react-bootstrap";
import { CloudConsultingServicesMeta } from "../data/metaData";
import { StaticImage } from "gatsby-plugin-image";
import LazyLoad from "react-lazy-load";
import Layout from "../components/layout/layout";

import WhyChooseUsIcon1 from "../images/icon/cloud-audit-optimisation-and-performance-services-cost.svg";
import WhyChooseUsIcon2 from "../images/icon/cloud-consulting-services-scalability-agility.svg";
import WhyChooseUsIcon3 from "../images/icon/aws-serverless-services-faster-development.svg";
import WhyChooseUsIcon4 from "../images/icon/monitoring-and-server-maintenance-services-security.svg";

import videoName from "../images/video/cloud-page-banner.webm";

const ClientsTestimonial = React.lazy(() => import('../components/clients-testimonial'))
const BlogList = React.lazy(() => import('../components/blog/blog-list'))
const Faqs = React.lazy(() => import('../components/faqs'))
const CaseStudy = React.lazy(() => import('../components/case-study'))

export const Head = () => (
  <Seo
    title={CloudConsultingServicesMeta.metaTitle}
    description={CloudConsultingServicesMeta.metaDescription}
    ogImage={CloudConsultingServicesMeta.ogImage}
    twitterImage={CloudConsultingServicesMeta.twitterImage}
  />
)

const CloudConsultingServicesPage = () => {
  const Process = '../images/cloud-consulting-services-process.png'
  const CTABgDark = '../images/cta-bg-dark1.png'
  const Image1 = '../images/index-team-3.png'
  const Image2 = '../images/index-team-2.png'
  const Image3 = '../images/index-team-1.png'
  const Image4 = '../images/index-team-4.png'
  const improvingdata = [
    {
      title: "Cloud assessment & planning",
      des: "Uncover key insights to create a powerful cloud strategy that meets your unique challenges. Our evaluations ensure your cloud platforms align perfectly with your business goals.",
      // linktext: "Optimize with Kubernetes",
      // url: "/web-application-development.html"
    },
    {
      title: "Cloud architecture design",
      des: "Get agile and scalable cloud architectures that solve your toughest challenges. Our solutions are crafted to adapt to evolving needs and optimize performance.",
      // linktext: "Simplify with Dockerization",
      // url: "/web-application-development.html"
    },
    {
      title: "Migration & deployment",
      des: "We tackle the complexities of cloud migration, ensuring a seamless transition with minimal disruption. Our strategic planning guarantees efficient, cost-effective deployment.",
      // linktext: "Power up with ECS",
      // url: "/web-application-development.html"
    },
    {
      title: "Security & compliance",
      des: "We identify vulnerabilities and fortify your infrastructure from evolving threats. Our cloud security consulting services guarantee compliance and secure data management.",
      // linktext: "Simplify with Dockerization",
      // url: "/web-application-development.html"
    },
  ]

  const WhyChooseUs = [
    {
      iconclass: WhyChooseUsIcon1,
      title: "Cost savings",
      des: "Being amongst the leading cloud consulting firms, we help you optimize cloud resources, reduce infrastructure costs, and ensure you only pay for what you use.",
    },
    {
      iconclass: WhyChooseUsIcon2,
      title: "Scalable solutions",
      des: "Our custom cloud solutions grow with your business, allowing you to quickly scale your infrastructure up or down as needed.",
    },
    {
      iconclass: WhyChooseUsIcon3,
      title: "Improved performance",
      des: "Utilsing the cloud’s high-performance capabilities, our cloud experts make sure to enhance the speed and efficiency of your operations.",
    },
    {
      iconclass: WhyChooseUsIcon4,
      title: "Enhanced security",
      des: "Our cloud security consultants implement resilient security measures, protecting your sensitive data and ensuring compliance with industry standards.",
    },
  ]

  const accordian = [
    {
      keyname: "list",
      seckey: "para",
      title: "What benefits can cloud consulting offer to my organization?",
      paragraph: "Cloud consultation services enhance your operations through:",
      list: [
        { list1: "Scalability: Scale resources based on demand." },
        { list1: "Cost Savings: Pay only for the cloud services you use, reducing upfront costs." },
        { list1: "Security: Advanced security measures to protect your data." },
        { list1: "Accessibility: Promotes team collaboration, boosting productivity." },
      ]
    },
    {
      title: "How do I know if cloud computing fits my IT strategy?",
      des: "We assess your current IT infrastructure, business goals, and industry needs to create a tailored cloud adoption strategy that aligns with your objectives."
    },
    {
      title: "How secure is my data in the cloud?",
      des: "The best cloud consulting providers offer top-notch security, including data encryption and disaster recovery. Our cloud consultants ensure your data is fully protected throughout migration and in the cloud."
    },
    {
      title: "How long does the cloud migration process take?",
      des: "Migration duration varies based on the complexity of your infrastructure. Our team develops a custom plan to ensure smooth, timely, and efficient migration with minimal disruption."
    },
    {
      title: "What are the ongoing costs of cloud services?",
      des: "Cloud costs depend on usage and the services you select from different cloud consulting companies. We help optimize resources to ensure you only pay for what you need, minimizing long-term expenses."
    },
  ]
  const Expertise = [
    {
      title: "Public cloud",
      desc: "Simplify the transition to the public cloud with us. We tackle scalability and cost challenges to make sure you get reliable cloud solutions for your growing business.",
      keyname: "img1"
    },
    {
      title: "Hybrid cloud",
      desc: "Address the complexity of integrating on-premises and cloud systems with our cloud consultants. We deliver secure and flexible hybrid cloud solutions customized to your needs.",
      keyname: "img2"
    },
    // {
    //   title: "Multi-cloud",
    //   desc: "Overcome vendor lock-in and performance gaps with our strategic multi-cloud solutions. We optimize operations and ease across providers",
    //   keyname: "img3"
    // }
  ]
  const TeamBehind = [
    {
      title: "Cloud solutions architect",
      desc: "Designs scalable, secure, and high-performance cloud architectures with our top cloud experts for seamless cloud migration, integration, and optimization while aligning solutions with industry best practices.",
      keyname: "img1"
    },
    {
      title: "Cloud solutions architect",
      desc: "Designs scalable, secure, and high-performance cloud architectures with our top cloud experts for seamless cloud migration, integration, and optimization while aligning solutions with industry best practices.",
      keyname: "img2"
    },
    {
      title: "Cloud security specialist",
      desc: "Implements resilient security frameworks, compliance, and threat mitigation in cloud environments with our cloud security experts, enforcing best security practices against breaches.",
      keyname: "img3"
    },
    {
      title: "Cloud DevOps engineer",
      desc: "With our cloud DevOps professionals automate cloud deployments, CI/CD pipelines, and infrastructure management to improve operational efficiency and scalability of your infrastructures",
      keyname: "img4"
    },
  ]

  const excellencedevelopers = [
    {
      number: "01",
      title: "<strong>Challenge :</strong> A business experiences high cloud bills due to inefficient resource management.",
      des: "<strong>Resolution :</strong> We optimize costs by rightsizing, auto-scaling, and using reserved instances, while tracking usage to prevent unnecessary spending.",
    },

    {
      number: "02",
      title: "<strong>Challenge :</strong> Insecure cloud configurations lead to breaches and unauthorized access.",
      des: "<strong>Resolution :</strong> We implement IAM, MFA, encryption, and regular security audits to secure data and prevent vulnerabilities.",
    },
    {
      number: "03",
      title: "<strong>Challenge :</strong> Cloud adoption doesn’t align with business goals, causing inefficiency.",
      des: "<strong>Resolution :</strong> We create a customized cloud strategy that matches your business needs and selects the right cloud models and architecture.",
    },
    {
      number: "04",
      title: "<strong>Challenge :</strong> Difficulty meeting industry compliance standards post-cloud migration.",
      des: "<strong>Resolution :</strong> We ensure cloud compliance by using built-in frameworks, continuous monitoring, and regular audits to meet legal and regulatory requirements.",
    },
    // {
    //   number: "05",
    //   title: "<strong>Challenge :</strong> Migration leads to downtime and data loss.",
    //   des: "<strong>Resolution :</strong> We use phased migrations, data validation tools, and backup plans to ensure smooth transitions with minimal downtime and data integrity.",
    // },
  ]
  const industry = [
    {
      title: "Cloud-native development",
      url: "/cloud-native-development-services.html",
      iconclass: "healthcare"
    },
    {
      url: "/cloud-migration-services.html",
      title: "Cloud migration services",
      iconclass: "education"
    },
    {
      title: "Cloud managed services",
      url: "/cloud-managed-services.html",
      iconclass: "retail",
    }
  ]
  return (
    <>
      <Layout headerClass="navbar-dark">
        <section className="section section-background video-banner bg-black min-vh-100 d-flex align-items-center flex-column">
          <Container className="py-5 my-auto">
            <div className="text-center max-width-950 mx-auto">
              <h1 className="sub-title mb-3 text-white-75">CLOUD CONSULTING SERVICES</h1>
              <h2 className="mb-4 h1 text-white">
                Make your <span className="text-primary">infrastructures future</span> ready.
                Get cloud ready!
              </h2>
              <p className="lead text-white-75 mb-5">
                Take your business to the next level with our expert cloud consulting services. We analyze your goals, systems, and challenges to create the best cloud strategy for your business. Our team, skilled in different cloud platforms, solves complex problems with ease ensuring the best advice custom to your needs. Achieve faster growth, better efficiency, and more flexibility with our customized cloud solutions.
              </p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline">
                Get cloud consultation now
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <div className="section-background-image">
              <video playsInline loop={true} autoPlay={true} muted width="100%" height="100%" controls={false}>
                <track kind="captions" srcLang="en" label="English" />
                <source src={videoName} type="video/webm"></source>
              </video>
            </div>
          </LazyLoad>
        </section>
        <section className="section">
          <Container className="py-5">
            <Row className="g-5">
              <Col lg={6}>
                <div className="sticky-section">
                  {/* <h2 className="sub-title mb-3">CLOUD COMPUTING CONSULTING SERVICES</h2> */}
                  <h2 className="mb-4">
                    Drive results with top <span className="text-primary">cloud computing consulting services</span>
                  </h2>
                  <p className="lead">Bring out the full potential of your business with our advanced cloud consulting services. By conducting thorough security and platform assessments our team of certified cloud engineers & architects design agile architectures and plan seamless migrations. We make sure your cloud strategy is optimized for enhanced performance, security, and growth.</p>
                  <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-3">
                    Get expert cloud consultation
                  </Link>
                </div>
              </Col>
              <Col lg={6}>
                <Row className="g-4" xs={1} md={1} lg={1}>
                  {improvingdata.map((item, index) => (
                    <Col key={index}>
                      <div className="dark-box-1 border">
                        <h3 className="h4 mb-3">{item.title}</h3>
                        <p className="mb-0">{item.des}</p>
                        {item.linktext ?
                          <Link to={item.url} className="btn btn-link px-0 mt-3">
                            <span>{item.linktext}</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                          </Link> :
                          null
                        }
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>


        <section className="section bg-black">
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              {/* <h2 className="sub-title mb-3 text-white-75">CLOUD CONSULTING PROVIDER</h2> */}
              <h2 className="text-white mb-4">
                Our customer-centric <span className="text-primary">cloud consulting approach</span>
              </h2>
              <p className="lead mb-0 text-white-75">Our structured process offers you a seamless cloud journey. From assessment and strategy to migration, architecture design, and ongoing support. Our cloud computing consulting services address your unique challenges to deliver custom, secure, and scalable cloud solutions.</p>
            </div>
            <div className="text-center">
              <StaticImage loading="lazy" src={Process} alt="cloud-consulting-services-process" width={1234} height={450} />
            </div>
          </Container>
        </section>

        <section className="section bg-white">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <div className="section-title ">
                <h2 className="heading fw-semibold mb-4">
                  Get expertise in diverse <span className="text-primary">cloud deployments</span>
                </h2>
                <p className="lead mb-0 max-width-950">
                  Our cloud computing consulting experts are skilled in a variety of cloud deployment models. From migration to full-scale deployments, as one of the top cloud consulting company we handle all clouds with precision and reliability.
                </p>
              </div>
            </div>
            <Row className="g-5" xs={1} md={2} lg={2}>
              {Expertise?.map((item, index) => (
                <Col key={index}>
                  <div className="expertised-left-border">
                    <div className="border-start ps-3 mb-4">
                      <h3 className="h4">{item.title}</h3>
                    </div>
                    <p className="mb-0 ps-3">{item.desc}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              <h2 className="mb-4">Overcoming common <span className="text-primary">cloud adoption challenges</span></h2>
              <p className="lead mb-0">Address key cloud challenges like cost overruns, data migration, security issues, and compliance with our cloud consulting expertise for a smooth transition and optimal performance. Here are some common challenges we encountered as cloud consulting firms that our cloud experts resolved skillfully: </p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={2}>
              {
                excellencedevelopers?.map((item, index) => {
                  return (
                    <Col key={index}>
                      <div className="dark-box-2 equal-height d-flex flex-column border-primary">
                        <p className="h1 text-primary me-3 lh-1 opacity-50 mb-4">{item.number}</p>
                        <p className="lead" dangerouslySetInnerHTML={{ __html: item.title }}></p>
                        <p className="lead mb-0" dangerouslySetInnerHTML={{ __html: item.des }}></p>
                      </div>
                    </Col>
                  )
                })
              }
            </Row>
          </Container>
        </section>
        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <div className="section-title ">
                <h2 className="heading fw-semibold mb-4">
                  Meet our <span className="text-primary"  >cloud consulting</span> experts
                </h2>
                <p className="lead mb-0 max-width-950">
                  With deep industry knowledge and hands-on experience our cloud solutions consultants help you navigate and utilize the cloud for ultimate business growth. Here’s our cloud consulting team who are making it all happen
                </p>
              </div>
            </div>
            <Row className="g-4" xs={1} md={1} lg={2}>
              {TeamBehind?.map((item, index) => (
                <Col key={index}>
                  <div className="card bg-light border-0 equal-height">
                    <div className="card-body ">
                      <div className="d-flex align-items-center0">
                        <div className="leader-box-image mb-0">
                          {
                            item.keyname === "img1" ?
                              <LazyLoad offsetVertical={1000}>
                                <StaticImage loading="lazy" src={Image1} width={110} height={110} alt="Team-Software" layout="fixed"  />
                              </LazyLoad> :
                              null
                          }
                          {
                            item.keyname === "img2" ?
                              <LazyLoad offsetVertical={1000}>
                                <StaticImage loading="lazy" src={Image2} width={110} height={110} alt="Team-Project-manager" layout="fixed" />
                              </LazyLoad> :
                              null
                          }
                          {
                            item.keyname === "img3" ?
                              <LazyLoad offsetVertical={1000}>
                                <StaticImage loading="lazy" src={Image3} width={110} height={110} alt="Tapan"  layout="fixed"/>
                              </LazyLoad> :
                              null
                          }
                          {
                            item.keyname === "img4" ?
                              <LazyLoad offsetVertical={1000}>
                                <StaticImage loading="lazy" src={Image4} width={110} height={110} alt="Tapan"  layout="fixed"/>
                              </LazyLoad> :
                              null
                          }
                        </div>
                        <div className="ms-3">
                          <h3 className="h4">{item.title}</h3>
                          <p className="mb-0">{item.desc}</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <CaseStudy
          sectionClass="bg-light"
          title="Our real-world wins: <span class='text-primary'>Cloud innovation</span> in action"
          description="Discover how our cloud consulting journey has empowered businesses, delivering innovative solutions that drive success and inspire transformation."
        />
        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              {/* <h2 className="sub-title mb-3">CLOUD CONSULTING COMPANY</h2> */}
              <h2 className="mb-4">
                Why choose us as your <span className="text-primary">cloud consulting company?</span>
              </h2>
              <p className="lead mb-0">Our cloud technology consultants bring expertise and experience to tackle your toughest challenges. We’re dedicated to delivering high-quality solutions that meet your needs. Explore how our expertise and commitment to quality deliver exceptional results.</p>
            </div>
            <Row className="g-4" xs={1} md={1} lg={2} xl={2}>
              {
                WhyChooseUs.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-1 equal-height">
                      <div className="d-flex align-items-start">
                        <Image loading="lazy" className="lazyload" width={50} height={50} src={item.iconclass} alt="Icon" />
                        <div className="ms-3">
                          <h3 className="font-size-22 mb-3">{item.title}</h3>
                          <p className="mb-0">{item.des}</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        <section className="section bg-black section-background">
          <Container className="py-5">
            <div className="text-center max-width-950 mx-auto">
              <h2 className="heading text-white mb-4">
                Schedule a call with our <span className="text-primary">cloud consultant expert.</span>
              </h2>
              <p className="lead text-white-75 mb-4">Whether you're starting fresh or need tweaks, our cloud experts are here to help—no strings attached!</p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Contact now
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Home banner pattren'
            />
          </LazyLoad>
        </section>
        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Maximizing your cloud: <span className="text-primary">What's next?</span>
              </h2>
              <p className="max-width-950 lead">Take the next step towards innovation with our comprehensive cloud solutions & services. Explore your next step in cloud action under certified cloud guidance.</p>
            </div>
            <Row as="ul" xs={1} sm={1} md={2} lg={3} className="list-unstyled g-4">
              {
                industry.map((item, index) => (
                  <Col as="li" key={index}>
                    {
                      <Link to={item.url} className="dark-box-1 d-flex align-items-center p-3 rounded-3">
                        {/* <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 me-3`}></i> */}
                        <i className="icon-check-square-sprite d-flex align-items-center icon-size-40 mb-0 me-3"></i>
                        <h3 className="h4 fw-normal mb-0 force-hover">{item.title}</h3>
                      </Link>
                    }
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>

        <ClientsTestimonial sectionClass="bg-light" title="Success stories shared by <span class='text-primary'>our clients</span>" description="See how we’ve helped businesses grow with our in-depth cloud consulting crafted by our expert cloud consultants." />

        <Faqs accordian={accordian} sectionClass="bg-white" />
        <BlogList
          title="More to <span class='text-primary'>explore</span>"
          description="Cloud learning never stops. Use our array of resources to stay current on all things cloud."
          sectionClass="bg-light"
          category='AWS / Cloud / DevOps'
        />
      </Layout>
    </>
  );
};

export default CloudConsultingServicesPage;
